/** Invite links (spec §6.4). The guest fills the PASS24 form at invite.pass24online.ru. */

const INVITE_ORIGIN = 'https://invite.pass24online.ru';
const PASS_PAGE = `${INVITE_ORIGIN}/?t=`;

/**
 * Only a clean PASS24 invite URL may be shared or turned into a QR. `chs` is dangerous: on some objects
 * opening such a link moves the pass to "inside" (spec §6.6), and the server's own sharedTokenQr carries it.
 */
export function safeInviteLink(link: string | null | undefined): string | null {
  if (!link) return null;
  let url: URL;
  try {
    url = new URL(link);
  } catch {
    return null;
  }
  if (url.origin !== INVITE_ORIGIN || /chs=/i.test(link)) return null;
  return link;
}

export function inviteMessage(objectName: string): string {
  return `Пропуск в ${objectName}: заполните номер машины или имя по ссылке — это займёт минуту.`;
}

export function passReadyMessage(objectName: string): string {
  return `Вам оформлен пропуск в ${objectName}. Время и адрес — по ссылке.`;
}

/** The guest's page of a ready pass (by its sharedToken), or null when there is nothing safe to share. */
export function passPageLink(sharedToken: string | null | undefined): string | null {
  return sharedToken ? safeInviteLink(`${PASS_PAGE}${encodeURIComponent(sharedToken)}`) : null;
}

/** Telegram's own share dialog, opened with Telegram.WebApp.openTelegramLink (TelegramApi.share). */
export function shareLink(link: string, text: string): string {
  const q = new URLSearchParams({ url: link, text });
  return `https://t.me/share/url?${q.toString()}`;
}
